import { Component, computed, Input, signal } from "@angular/core";
import CustomerSettings from "src/app/models/CustomerSettings";

@Component({
  selector: "app-shipping-package-graphic",
  templateUrl: "./shipping-package-graphic.component.html",
  styleUrl: "./shipping-package-graphic.component.scss",
  standalone: false,
})
export class ShippingPackageGraphicComponent {
  _length = signal(0);
  _width = signal(0);
  _height = signal(0);
  lengthModifier = computed(() => this._length() / this.getMainEdgeValue());
  widthModifier = computed(() => this._width() / this.getMainEdgeValue());
  heightModifier = computed(() => this._height() / this.getMainEdgeValue());

  totalScale = computed(() => this.widthModifier() + this.heightModifier() + this.lengthModifier());

  scaleAdjustment = computed(() => 1 / (this.totalScale() / 3));

  boxStyle = computed(() => {
    const sx = this.widthModifier();
    const sy = this.heightModifier();
    const sz = this.lengthModifier();

    const style = {
      transform: `rotateY(-2deg) rotateX(-30deg) rotateZ(2deg) scale3d(${sx}, ${sy}, ${sz}) scale(${this.scaleAdjustment()})`,
    };
    return style;
  });

  getMainEdgeValue = computed(
    () => [this._length(), this._width(), this._height()].sort((a, b) => b - a)[0],
  );

  @Input()
  set length(value: number) {
    this._length.set(value);
  }

  @Input()
  set width(value: number) {
    this._width.set(value);
  }

  @Input()
  set height(value: number) {
    this._height.set(value);
  }

  @Input() customerSettings: CustomerSettings;
}
